/**
 * Detects if the current platform is macOS.
 */
function isMacOS(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    /(Mac|iPod|iPhone|iPad)/i.test(navigator.userAgent)
  );
}

/**
 * Returns the appropriate keyboard shortcut symbol for the current OS.
 */
export function getCommandKey(): string {
  return isMacOS() ? '⌘' : 'Ctrl+';
}
